module.exports = __webpack_public_path__ + "media/images/curve-logo-on-black-d603f702910bdd79b806193c32450857.jpg";